
/* injects from baggage-loader */

'use strict';

// index.html page to dist folder
// import '!!file-loader?name=[name].[ext]!../favicon.ico';

// vendor files
import "./index.vendor";

// main App module
import "./index.module";

// main style
import "../assets/styles/sass/index.scss";

angular.element(document).ready(() => {
  angular.bootstrap(document, ['historicFunds'], {
    strictDi: true
  });
});



// WEBPACK FOOTER //
// ./src/app/index.bootstrap.js